import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['select', 'input']

  connect() {
    this.originalInput = this.inputTarget.value
  }

  selectTemplate() {
    const option = this.selectTarget.querySelector('option:checked')
    const body = option.dataset.body
    if (body) {
      this.inputTarget.value = body
    } else {
      this.inputTarget.value = this.originalInput
    }
  }
}
